import React from 'react';
import { compose, withState } from 'recompose';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { InputGroup } from 'reactstrap';
import isEmail from 'validator/lib/isEmail';
import { ModalBody, ModalHeader } from '../modal-helpers';
import { StoreState } from '@mm/state/store-interfaces';
import ContactsCRUDActions from '@mm/state/actions/ContactsCRUDActions';
import AudiencesCRUDActions from '@mm/state/actions/AudiencesCRUDActions';
import TextInput from '../../../common/components/TextInput';
import Button from '../../buttons/DeprecatedButton/DeprecatedButton';
import './ContactsExportModal.scss';

type OuterProps = {
  closeModal: Function;
  facebookPageId: number;
  botId: number;
  audienceId: number;
};

type PropsFromDispatch = ReturnType<typeof mapDispatchToProps>;
type PropsFromWithState = {
  email: string;
  setEmail: (value: string) => string;
  error: string;
  setError: (value: string) => string;
};

type OwnProps = OuterProps & PropsFromWithState;
type InnerProps = PropsFromWithState & PropsFromDispatch;
type Props = OuterProps & InnerProps;

const mapDispatchToProps = (
  dispatch: Dispatch<StoreState>,
  ownProps: OwnProps,
) => ({
  scheduleExport: inputEmail => {
    const email = inputEmail && inputEmail.trim();
    if (email) {
      const { facebookPageId, audienceId, botId, closeModal, setError } =
        ownProps;
      if (isEmail(email)) {
        if (facebookPageId) {
          dispatch(
            ContactsCRUDActions.createScheduledExport(facebookPageId, email),
          );
        } else if (botId && audienceId) {
          dispatch(
            AudiencesCRUDActions.createScheduledExport(
              botId,
              audienceId,
              email,
            ),
          );
        }
        closeModal();
      } else {
        setError('Please enter a valid email.');
      }
    }
  },
});

const ContactsExportModal = (props: Props) => {
  const { closeModal, email, setEmail, error, scheduleExport } = props;

  return (
    <div className="contacts-export-modal">
      <ModalHeader>
        <h3>Contact Export</h3>
      </ModalHeader>
      <ModalBody>
        <p>
          We’ll prepare your Contact export and email you when it’s ready. Enter
          the email address you’d like us to send your download link to.
        </p>
        <InputGroup className="mb-3 chatbot__input-group page-overview__text-input">
          <TextInput
            placeholder="Enter email address"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
          <p className="contacts-export-modal__error">{error}</p>
        </InputGroup>
        <Button
          className="contacts-export-modal__btn"
          onClick={() => scheduleExport(email)}
        >
          OK
        </Button>
        <Button red className="contacts-export-modal__btn" onClick={closeModal}>
          Cancel
        </Button>
      </ModalBody>
    </div>
  );
};

const enhance = compose<InnerProps, OuterProps>(
  withState('email', 'setEmail', ''),
  withState('error', 'setError', ''),
  connect(null, mapDispatchToProps),
);

export default enhance(ContactsExportModal);
